export default __webpack_public_path__ + "static/media/exclm.729c46a9.svg";